import { FormItemProps } from '../templates/FormProps';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { customSearch } from '@vindr/utils/helpers/common.helper';
import { Form, Select, SelectProps } from 'antd';
import type { InternalFieldProps } from 'rc-field-form/lib/Field';
import { useTranslation } from 'react-i18next';

export type FormSelectProps = Omit<SelectProps, 'children'> &
  Omit<InternalFieldProps, 'name' | 'children'> &
  FormItemProps & {
    mode?: 'multiple' | 'tags';
    loading?: boolean;
    onChange?: (value: any) => void;
    children?: JSX.Element | JSX.Element[];
    searchVietnamese?: boolean;
    allowClear?: boolean;
    options?: SelectProps['options'];
    defaultValue?: SelectProps['defaultValue'];
    wrapperClassName?: string;
    className?: string;
    showSearch?: boolean;
  };

const FormSelect = ({
  name = '',
  label = '',
  placeholder = '',
  rules,
  mode,
  loading,
  children,
  onChange,
  disabled,
  searchVietnamese = true,
  allowClear = true,
  required,
  options,
  defaultValue,
  className,
  showSearch,
  noStyle,
  wrapperClassName,
  ...props
}: FormSelectProps) => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <Form.Item
      name={name}
      {...(label && { label: t(label) })}
      rules={rulesMemo}
      noStyle={noStyle}
      className={wrapperClassName}
    >
      <Select
        allowClear={allowClear}
        className={className}
        placeholder={t(placeholder)}
        disabled={disabled}
        showSearch={showSearch}
        {...(onChange && { onChange })}
        {...(mode && { mode })}
        loading={loading}
        filterOption={(input, option) => customSearch(input, option, searchVietnamese, t)}
        options={options}
        defaultValue={defaultValue}
        {...props}
      >
        {!options && children}
      </Select>
    </Form.Item>
  );
};

export default FormSelect;
